import type { DehydratedState } from "@tanstack/vue-query";
import {
  dehydrate,
  hydrate,
  QueryClient,
  VueQueryPlugin,
} from "@tanstack/vue-query";

export default defineNuxtPlugin((nuxt) => {
  const vueQueryState = useState<DehydratedState | null>("vue-query");

  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 1000 * 60 * 10,
        // SSR clients belong to one request. A finite gcTime keeps their query
        // closures (including component state and JSDOM windows) alive via timers.
        // Infinity disables those timers so completed requests can be collected.
        gcTime: process.server ? Infinity : 1000 * 60 * 20,
      },
    },
  });

  nuxt.vueApp.use(VueQueryPlugin, { queryClient });

  if (process.server) {
    nuxt.hooks.hook("app:rendered", () => {
      vueQueryState.value = dehydrate(queryClient);
    });
  }

  if (process.client) {
    nuxt.hooks.hook("app:created", () => {
      hydrate(queryClient, vueQueryState.value);
    });
  }
});
